import React from "react"
import { Link } from "gatsby"
import Clock from 'react-digital-clock';
import { useStaticQuery, graphql } from 'gatsby'
import Img from 'gatsby-image'

import Layout from '../components/layout'
import { css } from "@emotion/core"
import '../styles/index.scss'
import headerStyles from '../styles/header.module.scss'
import aboutStyles from '../styles/about.module.scss'
import { IoIosArrowRoundDown } from "react-icons/io";
import Metatags from '../components/metatag';

// Background

import BackgroundX from "../../static/background-x.svg"
import BackgroundPoint from "../../static/background-point.svg"

// Tecnologies

import Gatsby from "../../static/gatsby.png"
import Eleventy from "../../static/11ty.png"
import Webflow from "../../static/webflow.png"
import Shopify from "../../static/shopify.png"
import Aws from "../../static/aws.png"
import Netlify from "../../static/netlify.png"


// Map

import spainmap from "../images/spainmap.svg"
import socialCard from '../images/card.jpg'

const today= new Date();
const hours = today.getHours();


//const weekday = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
//const day = weekday[today.getDay()];

const About = () => {

    const data = useStaticQuery(graphql`
        query{
            site{
                siteMetadata{
                    title
                    description
                    siteUrl
                }
            }
            felixgonzalo: file (relativePath: {eq: "felixgonzalo.jpg"}){
                id
                childImageSharp{
                  fixed{
                    ...GatsbyImageSharpFixed
                  }
                  fluid{
                    ...GatsbyImageSharpFluid
                  }
                }
            }
            image1: file (relativePath: {eq: "felixgonzalo.png"}){
                id
                childImageSharp{
                  fixed{
                    ...GatsbyImageSharpFixed
                  }
                  fluid{
                    ...GatsbyImageSharpFluid
                  }
                }
            }
            musula: file (relativePath: {eq: "musula.png"}){
                id
                childImageSharp{
                  fixed{
                    ...GatsbyImageSharpFixed
                  }
                  fluid{
                    ...GatsbyImageSharpFluid
                  }
                }
            }
            mousee: file (relativePath: {eq: "mousee.png"}){
                id
                childImageSharp{
                  fixed{
                    ...GatsbyImageSharpFixed
                  }
                  fluid{
                    ...GatsbyImageSharpFluid
                  }
                }
            }
            onehead: file (relativePath: {eq: "onehead.png"}){
                id
                childImageSharp{
                  fixed{
                    ...GatsbyImageSharpFixed
                  }
                  fluid{
                    ...GatsbyImageSharpFluid
                  }
                }
            }
            doly: file (relativePath: {eq: "doly.png"}){
                id
                childImageSharp{
                  fixed{
                    ...GatsbyImageSharpFixed
                  }
                  fluid{
                    ...GatsbyImageSharpFluid
                  }
                }
            }
            apto: file (relativePath: {eq: "apto.png"}){
                id
                childImageSharp{
                  fixed{
                    ...GatsbyImageSharpFixed
                  }
                  fluid{
                    ...GatsbyImageSharpFluid
                  }
                }
            }
            thatsamore: file (relativePath: {eq: "thatsamore.png"}){
                id
                childImageSharp{
                  fixed{
                    ...GatsbyImageSharpFixed
                  }
                  fluid{
                    ...GatsbyImageSharpFluid
                  }
                }
            }
        }
    
    `)
    
    let message = '';
    
    if (hours >= 0 && hours < 8) {
        message = "Estoy durmiendo 💤!"
    } else if (hours >= 8 && hours < 13){
        message = "Desarrollando una web 👨‍💻"
    } else if (hours >= 13 && hours < 14){
        message = "Disfrutando del almuerzo 🍽"
    } else if (hours >= 14 && hours < 20){
        message = "Desarrollando una web 👨‍💻"
    }else if (hours >= 20) {
        message = "Descansando después de un largo día 😊"
    } else {
        message = "Desarrollando una web 👨‍💻"
    }   
    
  

    return(
        <Layout>
            <Metatags
                title={`${data.site.siteMetadata.title} | Sobre mi`}
                description="Mi nombre es Félix Gonzalo y soy diseñador y desarrollador web en Sevilla. Ayudo a empresas autónomos y particulares a alcanzar sus objetivos a través del desarrollo de sus sitios web."
                thumbnail={`${data.site.siteMetadata.siteUrl}${socialCard}`}
                url= {data.site.siteMetadata.siteUrl}
            />
            

            <section className={headerStyles.header_wrapper}>

                <div className={headerStyles.header_wrapper_left}>
                    <h1 className={headerStyles.header_wrapper_title}>Sobre mí</h1>
                    <h2 className={headerStyles.header_wrapper_main}>Félix Gonzalo, <span className={headerStyles.header_wrapper_main_highlight}> Diseñador web </span> en <span className={headerStyles.header_wrapper_main_highlight}>Sevilla.</span>
                    </h2>
                    <p className={headerStyles.header_wrapper_text}>Ayudo a empresas y emprendedores en Sevilla a alcanzar su potencial, desarrollando webs con la tecnología del futuro.</p>
                    <Link to='sobre-mi#sobremi' className="btn btn__white btn__animated">Conóceme</Link>
                </div>

                <div className={headerStyles.header_wrapper_right}>
                    <Img fluid={data.image1.childImageSharp.fluid} alt='Felix Gonzalo' loading="lazy"/>
                </div>
                
            </section>
            <IoIosArrowRoundDown className={headerStyles.header_arrow} />

            <section className={aboutStyles.about} id='sobremi'>
                <div className={aboutStyles.about_wrapper}>
                    <div className={aboutStyles.about_wrapper_left}>
                        <h2 css={css`
                          font-size: 4rem; 
                          font-weight: 700;

                          @media (max-width:500px){
                            font-size: 7vh;
                          }

                        `}>Sobre mi</h2>
                        <p css={css`
                          line-height: 1.7; 
                          font-size: 1.3rem; 
                          width: 75%;

                          @media (max-width:700px){
                            width: 100%;
                          }
                        
                        `}>
                        Soy desarrollador web y marketer digital, cuyo objetivo es ayudar a empresas, autónomos y particulares a conseguir sus objetivos desarrollando páginas webs de éxito, de alto rendimiento, seguras y fáciles de mantener.<span role="img" aria-label="cohete">🚀</span>
                        </p>
                        
                    </div>

                    <div className={aboutStyles.about_wrapper_right}>
              
                      <Img fluid={data.felixgonzalo.childImageSharp.fluid} alt="Felix Gonzalo" loading="lazy"/>
                        
                    </div>
                    
                </div>


                <div className={aboutStyles.about_wrapper}>
                    <div className={aboutStyles.about_wrapper_mid}>

                        <p css={css`line-height: 1.7; font-size: 1.3rem;`}>
                        Después de haber trabajado como experto en marketing digital y desarrollo web para diferentes agencias y startups y de colaborar con otros diseñadores y desarrolladores, creo que es el momento de poder aplicar todo ese conocimiento para ayudar a empresas/autónomos a dar su salto al mundo digital, a través de su página web.
                        </p>
                        
                    </div>
                    
                </div>
                
            </section>


            <section className={aboutStyles.vision}>

                <div className={aboutStyles.vision_wrapper}>

                    <h2 css={css`
                      font-size: 4rem; 
                      font-weight: 700;
                      
                      @media (max-width:500px){
                        font-size: 7vh;
                      }
                    `}>Visión</h2>
                    <p css={css`
                      line-height: 1.7; 
                      font-size: 1.3rem; 
                      width: 80%; 
                      text-align: center;
                      
                      @media (max-width:900px){
                        width: 95%;
                      }
                    
                    
                    `}>Mi visión es desarrollar páginas web diseñadas y enfocadas a la venta, a la generación de clientes potenciales y el aumento de los ingresos.</p>
                        
                    <p css={css`
                      line-height: 1.7; 
                      font-size: 1.3rem; 
                      width: width: 80%; 
                      text-align: center;

                      @media (max-width:900px){
                        width: 95%;
                      }
                    `}>Web super rápidas <span role="img" aria-label="cohete">🚀</span> = Increíble UX <span role="img" aria-label="UX">👩🏻‍💻</span> = Ventas <span role="img" aria-label="Ventas">🎯</span></p>
                </div>

                <div className={aboutStyles.vision_wrapper_left}>

                    <div css={css`
                                        position: absolute;
                                        width: 26%;
                                        height: 58%;
                                        top: 14%;
                                        left: 40%;                              
                                        display: block;
                                        background-image: url(${BackgroundX});
                                        background-size: 12px;
                                        background-repeat: repeat;
                                        z-index: 0;

                                        @media (max-width: 1000px){
                                          width: 27%;
                                          height: 58%;
                                          top: 14%;
                                          left: 50%;
                                        }

                                        @media (max-width: 600px){
                                          left:70%;
                                        }

                                        @media (max-width: 420px){
                                          left:73%;
                                        }
                    `}></div>

                    <div className={aboutStyles.vision_wrapper_left_box}>

                        <p css={css`
                          line-height: 1.7; 
                          font-size: 1.2rem;

                          @media (max-width: 420px){
                            line-height: 1.3; 
                          }
                        `}>
                        Como <strong>Desarrollador y Diseñador Web</strong>, me gusta apostar por la <strong>última tecnología</strong>. Soy desarrollor frontend, quiere decir que desarrollaré y diseñaré todos los componentes visibles de tu sitio web. Para ello utilizaré tecnologías como HTML, CSS, SASS, JavaScript, JAMStack y React para <strong>construir una web super rápida</strong>. Integraré un CMS como Netlify CMS, Webflow o Contentful, para que <strong>puedas editarla tu mismo</strong>.
                        </p>
                                

                    </div>
                    
                </div>

                <div className={aboutStyles.vision_wrapper_right}>

                    <div css={css`
                                        position: absolute;
                                        width: 37%;
                                        height: 122%;
                                        left: 33%;
                                        bottom: -24%;                               
                                        display: block;
                                        background-image: url(${BackgroundPoint});
                                        background-size: 10px;
                                        background-repeat: repeat;
                                        z-index: 8;

                                        @media (max-width: 1000px){
                                          left: 20%;
                                        }

                                        @media (max-width: 600px){
                                          left:0%;
                                          height: 100%;
                                          bottom: -18%;
                                        }
                    `}></div>

                    <div className={aboutStyles.vision_wrapper_right_box}>

                        <p css={css`
                          line-height: 1.7; 
                          font-size: 1.2rem;

                          @media (max-width: 420px){
                            line-height: 1.3; 
                          }
                        `}>
                        Como <strong>Marketer Digital</strong>, desarrollo la <strong>parte creativa de la web</strong>, la <strong>estrategia</strong> a implantar para <strong>alcanzar tu objetivo</strong>. El desarrollo de un sitio no se basa sólo en crear una página web, subirla a un dominio y esperar a que lleguen resultados. <strong>Tu página debe tener una estrategia clara</strong>.
                        
                        </p>
                        
                    </div>
                    
                </div>

            </section>

            <section className={aboutStyles.brands}>

                <div className={aboutStyles.brands_wrapper}>

                    <h2 css={css`
                      font-size: 4rem; 
                      font-weight: 700;

                      @media (max-width:500px){
                        font-size: 7vh;
                      }
                    `}>Marcas</h2>
                    <p css={css`
                      line-height: 1.7; 
                      font-size: 1.3rem; 
                      width: 80%; 
                      text-align: center;

                      @media (max-width:900px){
                        width: 95%;
                      }
                    `}>A lo largo de mi carrera he trabajado con empresas en españolas e internacionales.</p>

                    <div className={aboutStyles.brands_wrapper_names}>
                        <div className={aboutStyles.brands_wrapper_names_img} css={css`width:11rem !important;`}>
                           <Img fluid={data.thatsamore.childImageSharp.fluid} alt='ThatsAmore wedding planner' loading="lazy"/>
                        </div>
                        <div className={aboutStyles.brands_wrapper_names_img}>
                           <Img fluid={data.mousee.childImageSharp.fluid} alt='mousee' loading="lazy"/>
                        </div>
                        <div className={aboutStyles.brands_wrapper_names_img}>
                           <Img fluid={data.apto.childImageSharp.fluid} alt='apto skincare' loading="lazy"/>
                        </div>
                        <div className={aboutStyles.brands_wrapper_names_img}>
                           <Img fluid={data.onehead.childImageSharp.fluid} alt='OneHead Hair' loading="lazy"/>
                        </div>
                        <div className={aboutStyles.brands_wrapper_names_img}>
                           <Img fluid={data.doly.childImageSharp.fluid} alt='DolyDoly' loading="lazy"/>
                        </div>
                        <div className={aboutStyles.brands_wrapper_names_img}>
                           <Img fluid={data.musula.childImageSharp.fluid} alt='Musula' loading="lazy"/>
                        </div>
                    </div>

                    <Link className="btn_small btn_small__gold" to="/portfolio">Ver portfolio</Link>
                        
                </div>

            </section>

            <section className={aboutStyles.tech}>

                <div className={aboutStyles.tech_wrapper}>
                      <h3 css={css`font-size: 13px;
                              line-height: 30px;
                              text-transform: uppercase;
                              letter-spacing: 2px;
                              color: #A58861;
                              margin-bottom: 5px;
                              text-align: left;`}>Detrás de cada proyecto</h3>
                      <h2 css={css`
                        font-size: 4rem; 
                        font-weight: 700; 
                        text-align: center;

                        @media (max-width:500px){
                          font-size: 7vh;
                        }
                      `}>Tecnología que uso</h2>

                      <p css={css`
                          line-height: 1.7; 
                          font-size: 1.3rem; 
                          width: 80%; 
                          text-align: center;
                          
                          @media (max-width:900px){
                            width: 95%;
                          }
                          
                          `}>
                        Cada proyecto es único, aunque algunas cosas pueden permanecen igual, elijo las herramientas que más se ajustan a lo que cada proyecto requiere.</p>

                      <div className={aboutStyles.tech_wrapper_box}>
                          <h3 css={css`font-size: 13px;
                              line-height: 30px;
                              text-transform: uppercase;
                              letter-spacing: 2px;
                              color: #A58861;
                              margin-bottom: 5px;
                              text-align: left;`}>Desarrollo</h3>
                          <div className={aboutStyles.tech_wrapper_box_logos}>
                            <img src={`${Gatsby}`} alt="gatsby" className={`${aboutStyles.tech_wrapper_box_logos_logo} ${aboutStyles.tech_wrapper_box_logos_logo_gatsby}`} loading="lazy"/>
                            <img src={`${Eleventy}`} alt="11ty" className={`${aboutStyles.tech_wrapper_box_logos_logo} ${aboutStyles.tech_wrapper_box_logos_logo_eleventy}`} loading="lazy"/>
                            <img src={`${Webflow}`} alt="Webflow" className={`${aboutStyles.tech_wrapper_box_logos_logo} ${aboutStyles.tech_wrapper_box_logos_logo_webflow}`} loading="lazy"/>
                            <img src={`${Shopify}`} alt="Shopify" className={`${aboutStyles.tech_wrapper_box_logos_logo} ${aboutStyles.tech_wrapper_box_logos_logo_shopify}`} loading="lazy"/>
                          </div>
                          
                          
                          

                      </div>

                      <div className={aboutStyles.tech_wrapper_box}>
                        <h3 css={css`font-size: 13px;
                                line-height: 30px;
                                text-transform: uppercase;
                                letter-spacing: 2px;
                                color: #A58861;
                                margin-bottom: 5px;
                                text-align: left;`}>Hosting & CDN</h3>
                                
                        <div className={aboutStyles.tech_wrapper_box_logos}>
                          <img src={`${Aws}`} alt="Amazon web service" className={`${aboutStyles.tech_wrapper_box_logos_logo} ${aboutStyles.tech_wrapper_box_logos_logo_aws}`} loading="lazy"/>
                          <img src={`${Netlify}`} alt="Netlify" className={`${aboutStyles.tech_wrapper_box_logos_logo} ${aboutStyles.tech_wrapper_box_logos_logo_netlify}`} loading="lazy"/>
                        </div>

                    </div>
                </div>
                
            </section>
        
            
            <section className={aboutStyles.status}>
                <div className={aboutStyles.status_wrapper}>
                    <div className={aboutStyles.status_wrapper_text}>
                        <h3>En este momento en Sevilla estoy...</h3>
                        <span>{message}</span>
                    </div>
                    
                    <div className={aboutStyles.status_wrapper_mappoint}>
                        <img className={aboutStyles.status_wrapper_mappoint_img} src={spainmap} alt='spain map' loading="lazy"/>
                        <span className={aboutStyles.status_wrapper_mappoint_location}></span>
                        <span className={aboutStyles.status_wrapper_mappoint_circle}></span>
                        
                    </div>

                    <div>
                        <h3 className={aboutStyles.status_wrapper_clock}><Clock hour12= {false} format= {'hh-mm'}/></h3>
                    </div>
                </div>
            </section>
            

        </Layout>
    )

}

export default About
